import { Component, NgZone, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-yearperiods',
  templateUrl: './yearperiods.component.html',
  styleUrls: ['./yearperiods.component.sass']
})
export class YearperiodsComponent implements OnInit {

  @ViewChild("slideToggle") toggleRef: ElementRef<MatSlideToggle>;

  public isEnabled;
  public isLoading = false;
  public yearperiodId;

  yearperiodsListSubs: Subscription;
  yearperiods: any;
  yearperiodForm: FormGroup;
  isList: boolean = true;
  isNew: boolean = true;
  modification_date: string;
  creation_date: string;
  logo_url: string;
  pageSize: number = 100;
  pageIndex: number = 0;

  showYearperiodProgressBar: boolean = true;

  displayedColumns: string[] = ['name', 'activated', 'modification_date', 'actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) { }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    if(localStorage.getItem('year-periods'))
    {
      let data = JSON.parse(localStorage.getItem('year-periods'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1
    }
  }


  ngOnInit() {
    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')) {
        this.router.navigate(['/welcome']);
      }

    });
    this.yearperiodForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      activated: new FormControl(false, Validators.required)
    });


    // this.yearperiods = this.getYearperiods();
    // this.routeSub =



    this.route.params.subscribe(params => {
      // ADDED PARAM TO RETRIEVE ALL YEARPERIODS FROM THIS COMPONENT
      this.dataService.getYearperiods({param: 'include-all'}).subscribe(yearperiods => {
        this.yearperiods = yearperiods;
        this.dataSource.data = this.yearperiods;
        this.showYearperiodProgressBar = false;
        // this.isLoading = false
      });
      if (params.id) {
        
        this.yearperiodId = params.id
        this.isList = false;
        if (params.id != 'new') {
          this.isLoading = true
          this.isNew = false;
          this.yearperiodsListSubs = this.dataService
            .getYearperiod(params.id) //cambiar por id en el html
            .subscribe(res => {
              
              this.yearperiods = res;
              this.yearperiodForm.controls["id"].setValue(this.yearperiods.id);
              this.yearperiodForm.controls["name"].setValue(this.yearperiods.name);
              this.yearperiodForm.controls["activated"].setValue(this.yearperiods.activated);
              this.isEnabled = this.yearperiods.activated;

              this.creation_date = this.yearperiods.creation_date;
              this.modification_date = this.yearperiods.modification_date;
              this.isLoading = false
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }


      }
      else {
        this.isList = true;
      }
    });
  }

  goTo(yearperiodID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    localStorage.setItem('year-periods', JSON.stringify(data))
    this.router.navigateByUrl(`yearperiod/${yearperiodID}`);
  }

  applyFilter(text: any) {
    const filterValue = (text.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  newYearperiod() {
    this.router.navigateByUrl(`yearperiod/new`);
  }


  saveYearperiod() {
    var params = {};
    params['name'] = this.yearperiodForm.controls["name"].value;
    params['id'] = this.yearperiodForm.controls["id"].value;
    // params['activated'] = this.yearperiodForm.controls["activated"].value;
    params['activated'] = this.isEnabled;



    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }


    this.dataService.saveYearperiod(params).subscribe(data => {
      if (data == '') {
        this.router.navigateByUrl(`yearperiods`);
      }
      else {
        this.translate.get('alerts.save_yearperiod_error').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
      }
    })
  }

  delete(yearperiodID: string) {
    alert("in construcction")
  }

  public onSliderToggle(slider: any){
    this.isLoading = true
    let params = {
      "yearperiod_id": this.yearperiodId,
      "enabled": !this.isEnabled
    }
    this.dataService.toggleYearperiodStatus(params).subscribe((res: any) => {
      if(res.status == 'success'){this.isEnabled = !this.isEnabled}
      else {
        this.translate.get('alerts.'+res.context).subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
      }
      this.isLoading = false
      slider.checked = this.isEnabled
    })
  }

}
